import api from 'api'
import { WageJurisdictionLevel } from 'pages/Wage/types'

export type WageJurisdiction = {
  id: number
  level: WageJurisdictionLevel
  name: string
  stateCode: string | null
  countyFips?: string | null
  placeGeoid?: string | null
}

type GetJurisdictionsRequest = {
  level?: WageJurisdictionLevel
  stateCode?: string
}

export const getJurisdictions = async (
  request: GetJurisdictionsRequest = {}
): Promise<WageJurisdiction[]> => {
  const response = await api.get<WageJurisdiction[]>(
    '/admin/wage/jurisdictions',
    {
      params: {
        level: request.level,
        state_code: request.stateCode,
      },
    }
  )
  return response.data
}
